import {
  generateBindings,
  ObservableValue,
  observableValue,
  useObservedValue,
  view,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-linear-progress';
import { html } from 'lit';

class Props {
  indeterminate = false;
  progress: number | ObservableValue<number> = 0;
  buffer: number | ObservableValue<number> = 1;
  reverse = false;
  closed: boolean | ObservableValue<boolean> = false;
}

export const [LinearProgress] = view('esui-mwc-linear-progress', {
  Props,

  mapBuilder:
    LinearProgressBuilder =>
    (progress = 0) =>
      LinearProgressBuilder().progress(progress),

  template(props) {
    const progress = useObservedValue(props.progress);
    const buffer = useObservedValue(props.buffer);
    const closed = useObservedValue(props.closed);
    const { reverse } = props;

    const computedProps = generateBindings({
      progress,
      buffer,
      closed,
      reverse,
    });

    return html`
      <mwc-linear-progress
        ${spread({ ...computedProps })}
      ></mwc-linear-progress>
    `;
  },
});
